module.exports = __webpack_public_path__ + "static/media/gora-p.6d1ed701.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResizableProduct/images/gora-p.png
// module id = 436
// module chunks = 0